// Format minutes to hours:minutes (e.g. 90 → "1:30")
export const formatDuration = (minutes) => {
  if (!minutes) return '0:00'
  const hrs = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hrs}:${mins.toString().padStart(2, '0')}`
}

// Format minutes as decimal hours (e.g. 90 → "1.5")
export const formatHours = (minutes) => {
  if (!minutes) return '0'
  return (minutes / 60).toFixed(1)
}
